import { useRouter } from "next/router";

import { OWN_ORIGIN } from "@/base/base.constants";
import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";

const useSignInUrl = () => {
  const { asPath } = useRouter() || { asPath: { text: "" } };
  const nextParam = OWN_ORIGIN + asPath;
  return `${MONOLITH_ORIGIN}/signin?next=${nextParam}`;
};

export default useSignInUrl;
